module.exports = __webpack_public_path__ + "img/RWBuild Summit Advertising Flag.515d8eff.png";